import { render, staticRenderFns } from "./IceHeader.vue?vue&type=template&id=0484a461&"
import script from "./IceHeader.vue?vue&type=script&lang=js&"
export * from "./IceHeader.vue?vue&type=script&lang=js&"
import style0 from "./IceHeader.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports